import React from "react";
import { QRCodeSVG } from "qrcode.react";
import aeonImage from "../assets/images/map.png";
import "../assets/Map.css"; // ✅ import the CSS

// ✅ Universal Google Maps link
const mapUrl = "https://maps.app.goo.gl/LWcyZnZ9jR76bFA18";

const MapQR = () => {
  return (
    <div className="map-qr-section">
      <h5 className="date1 mb-3 map-qr-title">📍 ទីតាំងកម្មវិធី</h5>

      {/* 🗺️ Map Image */}
      <img
        src={aeonImage}
        alt="Map to AEON Mall Mean Chey"
        className="map-qr-image"
      />

      {/* 📍 QR Code */}
      <a href={mapUrl} target="_blank" rel="noopener noreferrer">
        <div className="map-qr-code-wrapper">
          <QRCodeSVG value={mapUrl} size={50} />
        </div>
      </a>

      <p className="map-qr-note">📱 ស្កែនឬចុចដើម្បីមើលទីតាំង</p>
    </div>
  );
};

export default MapQR;
